(function () {
  class SpineSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._spine = undefined;
      this._trackInfo = undefined;
      this._animName = undefined;
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      trackInfo.showSymbol(false);
      this.initialiseSymbolSpine(this._spine, trackInfo.getPosition());
      let self = this;
      this._spine.play(this._animName, loop, undefined, undefined, function () {
        onCellAnimFinishedCb(self);
      });
    }

    initialiseSymbolSpine(spine, symPos) {
      this.visible = true;
      //   spine._spineObj.skeleton.setSkinByName("default");
      spine._spineObj.skeleton.setSlotsToSetupPose();
      spine.stop();
      spine.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }
  }

  let create = function () {
    return new SpineSymbolAnimator();
  };

  let initialise = function (json, instance) {
    instance._spine = resourceManager.createObject(
      "spine",
      "spine",
      instance.name,
      { name: json.playData.spineAnim }
    );
    instance._animName = json.playData.animName;

    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }

    if (json.playData.scale) {
      instance._spine.scale.set(json.playData.scale.x, json.playData.scale.y);
    }
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "SpineSymbolAnimatorEx",
    create,
    initialise,
    getRequiredFiles
  );
})();
